import Timer from 'tick-tock';

export default class Hero {
  constructor(element) {
    this.element = element;
    this.timer = new Timer();
    this.ready();
  }

  ready() {
    this.timer.setTimeout('delay', () => {
      this.element.classList.add('ready');
      this.timer.clear('delay');
    }, 350);
  }
}
